import React from "react"

const ASSETS_ORIGIN = (
  process.env.GATSBY_STATAMIC_ASSETS_URL || ""
).replace(/\/+$/, "")

const ATTR_RE = /(\b(?:src|href|poster|data-src|srcset)\s*=\s*)(["'])(\/(?!\/)[^"']*)\2/gi
const SRCSET_ITEM_RE = /(^|,\s*)(\/(?!\/)\S+)/g

export function prefixStatamicAssets(html, origin = ASSETS_ORIGIN) {
  if (!html || !origin) return html || ""
  return html.replace(ATTR_RE, (_match, attr, quote, url) => {
    if (attr.trim().toLowerCase().startsWith("srcset")) {
      const rewritten = url.replace(
        SRCSET_ITEM_RE,
        (_m, sep, path) => `${sep}${origin}${path}`
      )
      return `${attr}${quote}${rewritten}${quote}`
    }
    return `${attr}${quote}${origin}${url}${quote}`
  })
}

export function prefixStatamicAssetUrl(url, origin = ASSETS_ORIGIN) {
  if (!url || !origin) return url || ""
  if (url.startsWith("//") || /^https?:\/\//i.test(url)) return url
  if (url.startsWith("/")) return `${origin}${url}`
  return url
}

export function statamicAssetToFixed(asset, params = {}, assumed = {}) {
  if (!asset || !(asset.permalink || asset.url)) return null
  const base = prefixStatamicAssetUrl(asset.permalink || asset.url)
  const queryString = Object.entries(params)
    .map(([k, v]) => `${k}=${v}`)
    .join("&")
  const width = assumed.width || params.w || asset.width || null
  const height =
    assumed.height ||
    params.h ||
    (asset.width && asset.height && params.w
      ? Math.round(asset.height * (params.w / asset.width))
      : asset.height)
  return {
    fixed: {
      src: queryString ? `${base}?${queryString}` : base,
      width,
      height,
    },
    title: asset.alt || "",
  }
}

export function StatamicHtml({ html, as: Tag = "div", ...rest }) {
  return (
    <Tag
      {...rest}
      dangerouslySetInnerHTML={{ __html: prefixStatamicAssets(html) }}
    />
  )
}
